<i18n>
{
  "en": {
    "placeholders": {
      "email": "E-mail",
      "password": "Password"
    },
    "cta": "Sign-in my account"
  }
}
</i18n>

<script>
import { login } from '@/config/auth';

export default {
  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
    };
  },

  methods: {
    login() {
      this.isLoading = true;

      login(this.email, this.password)
        .then(() => {
          this.$emit('loggedin');
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$addMessage(error.message, 'danger');
          this.$trackError(error);
        });
    },
  },

  created() {
    this.$trackPageView('Login', '/modal/login');
  },
};
</script>

<template>
  <form @submit.prevent="login">
    <p>
      <label for="email" v-t="'placeholders.email'" />
      <input class="input" type="email" id="email" v-model="email" required>
    </p>
    <p class="mt-3">
      <label for="password" v-t="'placeholders.password'" />
      <input class="input" type="password" id="password" v-model="password" required>
    </p>
    <p v-show="isLoading" class="text-center mt-2 fsize-5 color-main" v-t="'loading'" />
    <p class="mt-3 text-center">
      <button type="submit" class="btn" v-t="'cta'" :disabled="isLoading" />
    </p>
  </form>
</template>
